import type { ComponentType } from "react";
import type { ConfigShowQueryType } from "@/types/graphql/admin.generated";
import { ConfigDetails } from "../ConfigDetails";

export const ConfigShowComponent: ComponentType<{
  editData?: unknown;
  id?: string;
  config?: ConfigShowQueryType["config"];
}> = ({ config }) => {
  if (!config) return <div>Загрузка...</div>;

  return <ConfigDetails config={config} />;
};
